<script>
import FileUpload from "vue-upload-component";
import api from "@services/api";
export default {
  components: {
    FileUpload
  },
  props: {
    closeModal: {
      type: Function
    },
    showFileModal: {
      type: Boolean
    },
    executePost: {
      type: Boolean
    },
    origemId: {
      type: Number
    },
    postUrl: {
      type: String
    },
    saveFileLocal: {
      type: Function
    }
  },
  data: function() {
    return {
      files: [],
      data: {
        _csrf_token: "xxxxxx"
      },
      name: "file",
      thread: 3
    };
  },
  methods: {
    inputFile(newFile, oldFile) {
      if (newFile != oldFile) {
        console.log(1);
      }
      this.$refs.upload.active = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    saveFiles() {
      if (this.executePost) {
        let formData = new FormData();

        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          formData.append("files[" + i + "]", file.file);
        }
        formData.append("chamadoId", this.origemId);

        api
          .post(`api/Chamado/UploadFile`, formData, {
            headers: {
              "Content-Type":
                "multipart/form-data;boundary=" +
                Math.random()
                  .toString()
                  .substr(2)
            }
          })
          .then(response => {
            if (response.data["status"].toLowerCase() == "success") {
              this.hasSuccess = true;
              this.closeModal(this.files[0].file);
            }
          });
      }

      if (!this.executePost) {
        this.closeModal(this.files[0].file);
        this.files = [];
      }
    }
  }
};
</script>

<template>
  <b-form class="p-2" ref="form">
    <div>
      <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
        <h3>Drop files to upload</h3>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Nome</th>
              <th>Tamanho (em bytes)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!files.length">
              <td colspan="7">
                <div class="text-center p-5">
                  <h4>Arraste os arquivos<br />ou</h4>
                  <label :for="name" class="btn btn-lg btn-primary"
                    >Selecione</label
                  >
                </div>
              </td>
            </tr>
            <tr v-for="(file, index) in files" :key="file.id">
              <td>{{ index }}</td>
              <td>
                <div class="filename">
                  {{ file.name }}
                </div>
              </td>
              <td>{{ file.size }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <file-upload
        class="btn btn-primary dropdown-toggle"
        :multiple="true"
        :data="data"
        :drop="true"
        v-model="files"
        @input-file="inputFile"
        @input-filter="inputFilter"
        ref="upload"
        :hidden="files.length ? false : true"
      >
        <i class="fa fa-plus"></i>Adicionar arquivo
      </file-upload>
    </div>
    <hr />
    <b-button variant="light" class="btn" v-on:click="saveFiles"
      >Cancelar</b-button
    >
    <b-button variant="primary" class="btn ml-2" v-on:click="saveFiles"
      >Salvar</b-button
    >
  </b-form>
</template>
